export const SET_EXPORT_FORMAT = '@@b2b_portal_ui/export/SET_EXPORT_FORMAT';

export const START_EXPORT = '@@b2b_portal_ui/export/START_EXPORT';
